const DisableRightClick = false; // true eller false
const onProductsPage = location.href.indexOf("/products") !== -1;
const onCartPage = location.href.indexOf("/cart") !== -1;
const jdgmInvite = location.href.indexOf("judgeme_dynamic_form") > 0;

$(document).ready(function(){ 

  if(DisableRightClick) {
    disableRightClick();
  }

  if(onProductsPage) {   
    removeUnwantedOptions(); //Judge-me
  }

});

window.onload = function() {
  if(jdgmInvite){
    jdgmInvitePlaceholders();
  }   
}

function disableRightClick() {
$("html").on("contextmenu",function(e){
   return false;
});  
}

// Start da-upsell
function showHideUpsell() { //Called from quick-cart.liquid
  let $el = $("#da-upsell-button");
  if($el.attr("data-show") == "true"){
    $el.attr("data-show", "false");
    $el.removeClass("da-upsell-minus").addClass("da-upsell-plus");
    $("#da-product-recommendations").slideUp();
  }
  else {
    $el.attr("data-show", "true");
    $el.removeClass("da-upsell-plus").addClass("da-upsell-minus");
    $("#da-product-recommendations").slideDown();  
  }
}

function cartDrawerLoad(){ //Called from quick-cart.liquid with img.onload() 
  //console.log("cartDrawerLoaded");
  if(!onCartPage) {
    removeDKK();
    createUpsell();   
  }
}

function removeDKK() {
 $(".quick-cart__item-price").each(function(){
   $(this).html($(this).html().replace("DKK", ""));
 });
  let elm = $(".quick-cart__footer-subtotal").find($(".ff-product-price"));
  let subtotal = elm.html().replace("DKK", "");
  elm.html(subtotal);
}

function getfirstCartItem() {
 $(".quick-cart").remove(); //remove cartdrawer so it does'nt intefere with da-upsell, no need for it, since we already are on cart-page
 let cartContents = fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { 
    if(data.items.length) {
      cartPageUpsell(data.items[0].product_id);
    }
    else {
      $("#da-upsell-wrapper").hide();
    }
   });
}

function cartPageUpsell(productId) {
  let url = "/recommendations/products?section_id=da-product-recommendations&limit=8&product_id="+productId;
  let request = new XMLHttpRequest();
  request.open("GET", url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) { 
      let container = document.createElement("div");
      container.innerHTML = request.response;
      document.getElementById("da-product-recommendations").innerHTML = container.querySelector("#da-collection-container").innerHTML;
     //Add swipe function
      new Glide(".glide", {
        gap: 12,
        peek: { before: 0, after: 40 }
      }).mount();
    }
  };
  request.send();
  
}

function createUpsell(){
  let productId = $(".quick-cart__item" ).first().attr("data-product-id");
  let url = "/recommendations/products?section_id=da-product-recommendations&limit=8&product_id="+productId;

  let request = new XMLHttpRequest();
  request.open("GET", url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) { 
      let container = document.createElement("div");
      container.innerHTML = request.response;
      document.getElementById("da-product-recommendations").innerHTML = container.querySelector("#da-collection-container").innerHTML;
     //Add swipe function
      new Glide(".glide", {
        gap: 12,
        peek: { before: 0, after: 40 }
      }).mount();
    }
  };
  request.send(); 
}

function addUpsellItemToCart(variantId) {

let formData = {
 'items': [{
  'id': variantId,
  'quantity': 1
  }]
};
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  //return response.json();
  let input = document.querySelector(".quantity-input input.quantity-input__input");
  input.dispatchEvent(new Event('change', { bubbles: true }));
})
.catch((error) => {
  console.error('Error:', error);
});
}
// End da-upsell

// start judge-me
function removeUnwantedOptions(){

      var jdgmDropDown = setInterval(function() {
   		if ($("select.jdgm-sort-dropdown").length) {
      	
			clearInterval(jdgmDropDown);
  			let i, arr = ["with-pictures", "pictures-first", "videos-first", "most-helpful"];
  			$("select.jdgm-sort-dropdown > option").each( function () {
    			for (i = 0; i < arr.length; i++) {
    				if($(this).val() == arr[i]) {
    					$(this).remove();
    					break;
  					}
  				}
  			});
			
   		}
	}, 200); // check every 200ms
}

function jdgmInvitePlaceholders() {
  $("#jdgm_reviewer_name").attr("placeholder", "Indtast dit fornavn");
  $("#jdgm_reviewer_email").attr("placeholder", "Indtast din email");
}
//end judge-me
